import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  dateBadge: {
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    borderRadius: '50px',
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '15px',
    height: '34px',
    padding: '0 12px',

    '&:not(.disabled)': {
      cursor: 'pointer',
      color: 'var(--primary-main)',
      backgroundColor: 'var(--primary-lighty)',

      '&:hover': {
        color: 'var(--toryBlueToPrimaryLight)',
        backgroundColor: 'var(--selection-iconsHover)',
      },
    },

    '&.empty': {
      color: 'var(--text-secondary)',
      minWidth: '170px',

      '& .viboIcon': {
        pointerEvents: 'none',
        position: 'absolute',
        left: '12px',

        '@media screen and (min-width: 1441px)': {
          left: '16px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        minWidth: '200px',
      },
    },

    '&.disabled': {
      color: 'var(--clr-white)',
      backgroundColor: 'var(--text-hint)',
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '18px',
      height: '40px',
      padding: '0 16px',
    },
  },
}));

export default useStyles;
